module.exports = __webpack_public_path__ + "img/functions_hover.7203b270.svg";